module.exports = __webpack_public_path__ + "img/img_dontai.687d7449.jpg";